<template>
  <div>
    <TransferenceManagebar />

    <v-container fluid class="pa-6" tag="section">
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between mb-2">
            <div>
              <h2 class="text-h4 font-weight-bold primary--text">
                <v-icon large color="primary" class="mr-2"
                  >mdi-file-document-check-outline</v-icon
                >
                สรุปผลการรายงานตัว ย้ายสายบริหาร (ผอ./รอง ผอ.)
              </h2>
              <div class="subtitle-1 grey--text text--darken-1 mt-1">
                ติดตามสถานะการรายงานตัวของสถานศึกษาปลายทาง รอบ
                {{ periods.period_times }}/{{ periods.period_year }}
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #455A64"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รายการทั้งหมด</div>
                <div class="text-h4 font-weight-bold">{{ stats.total }}</div>
              </div>
              <v-avatar color="info lighten-5" size="60">
                <v-icon color="info" x-large>mdi-format-list-bulleted</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #2E7D32"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รายงานตัวแล้ว</div>
                <div class="text-h4 font-weight-bold success--text">
                  {{ stats.reported }}
                </div>
              </div>
              <v-avatar color="success lighten-5" size="60">
                <v-icon color="success" x-large>mdi-account-check</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #A86400"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ไม่มารายงานตัว</div>
                <div class="text-h4 font-weight-bold warning--text">
                  {{ stats.not_reported }}
                </div>
              </div>
              <v-avatar color="warning lighten-5" size="60">
                <v-icon color="warning" x-large>mdi-account-alert</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #F44336"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ยังไม่รายงานตัว/รอดำเนินการ</div>
                <div class="text-h4 font-weight-bold error--text">
                  {{ stats.pending }}
                </div>
              </div>
              <v-avatar color="error lighten-5" size="60">
                <v-icon color="error" x-large>mdi-clock-alert</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card elevation="2" class="rounded-lg mb-4">
        <v-toolbar flat color="white" class="pt-2">
          <v-row align="center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา ชื่อ, วิทยาลัย, หรือรหัส..."
                single-line
                hide-details
                outlined
                dense
                rounded
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="times_select"
                :items="time_ss"
                label="ครั้งที่"
                outlined
                dense
                hide-details
                rounded
              ></v-select>
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="years_select"
                :items="year_ss"
                label="ปีงบประมาณ"
                outlined
                dense
                hide-details
                rounded
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                block
                rounded
                depressed
                @click="searchTimeYear"
              >
                <v-icon left>mdi-filter</v-icon> ค้นหา
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="success"
                outlined
                block
                rounded
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> Export
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-expansion-panels flat accordion class="mt-2">
          <v-expansion-panel>
            <v-expansion-panel-header class="grey lighten-4">
              <span class="text-subtitle-2 grey--text text--darken-2">
                <v-icon small class="mr-2">mdi-table-cog</v-icon>
                ปรับแต่งคอลัมน์ตาราง
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-4">
              <v-select
                v-model="selectedHeaders"
                :items="headersMap"
                label="เลือกคอลัมน์ที่ต้องการแสดง"
                multiple
                outlined
                dense
                chips
                small-chips
                deletable-chips
                return-object
              ></v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>

      <v-card elevation="2" class="rounded-lg">
        <v-data-table
          :headers="showHeaders"
          :items="conditons_transfer_successs"
          :search="search"
          :loading="loading"
          class="elevation-0"
          :items-per-page="10"
        >
          <template v-slot:item.cts_report="{ item }">
            <div v-if="item.cts_college_cc === 'CC'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    rounded
                    color="error lighten-1"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="cancelmvDirector(item.id_cts)"
                  >
                    <v-icon left small>mdi-close-circle</v-icon> ขอยกเลิก
                  </v-btn>
                </template>
                <span>คลิกเพื่อดำเนินการยกเลิก</span>
              </v-tooltip>
            </div>
            <div v-else>
              <v-chip
                v-if="item.cts_report === 'nb'"
                color="success"
                small
                label
              >
                <v-icon left small>mdi-check</v-icon> รายงานตัวแล้ว
              </v-chip>
              <v-chip
                v-else-if="item.cts_report === 'dnb'"
                color="warning"
                small
                label
              >
                <v-icon left small>mdi-alert</v-icon> ไม่มารายงานตัว
              </v-chip>
              <v-chip v-else color="grey lighten-1" dark small label>
                รอดำเนินการ
              </v-chip>
            </div>
          </template>

          <template v-slot:item.cts_datetime="{ item }">
            <div
              v-if="item.cts_report === 'nb'"
              class="primary--text font-weight-bold"
            >
              {{
                item.cts_datetime
                  | moment("add", "543 years")
                  | moment("D MMMM YYYY")
              }}
            </div>
            <div v-else class="grey--text text-caption">-</div>
          </template>

          <template v-slot:item.cts_files="{ item }">
            <v-btn
              v-if="item.cts_report === 'nb'"
              icon
              color="primary"
              :href="'/HRvecfiles/' + item.cts_files"
              target="_blank"
            >
              <v-icon>mdi-file-download</v-icon>
            </v-btn>
            <v-icon v-else color="grey lighten-2">mdi-file-hidden</v-icon>
          </template>

          <template v-slot:item.college_name_old="{ item }">
            <span class="grey--text text--darken-2">{{
              item.college_name_old
            }}</span>
          </template>
          <template v-slot:item.college_name_new="{ item }">
            <div class="d-flex align-center">
              <v-icon small color="info" class="mr-1"
                >mdi-arrow-right-bold</v-icon
              >
              <span class="info--text font-weight-bold">{{
                item.college_name_new
              }}</span>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2" dark>{{ snackbar.icon }}</v-icon>
        <span class="white--text">{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="snackbar.show = false"
          >ปิด</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import TransferenceManagebar from "../../components/admin/transferenceManagebar.vue";
import * as XLSX from "xlsx"; // Requires npm install xlsx
import { saveAs } from "file-saver"; // Requires npm install file-saver
import { logSensitiveAccess } from "@/utils/sensitiveAccessLog";

export default {
  name: "TransferReportMVDirector",
  components: { TransferenceManagebar },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      search: "",

      // Selectors
      times_select: "",
      years_select: "",
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],

      // Data
      conditons_transfer_successs: [],
      periods: {},
      conditons_transfer_successs_director: {},

      // Table Config
      selectedHeaders: [],
      headersMap: [
        {
          text: "สถานะรายงานตัว",
          align: "center",
          value: "cts_report",
          width: "150px"
        },
        { text: "วันที่", align: "center", value: "cts_datetime" },
        { text: "เอกสาร", align: "center", value: "cts_files" },
        { text: "สังกัดใหม่", align: "left", value: "college_name_new" },
        { text: "เลขที่ตำแหน่งใหม่", align: "center", value: "ctsid_position" },
        {
          text: "คำนำหน้าชื่อ",
          align: "left",
          value: "title_s",
          sortable: false
        },
        { text: "ชื่อ", align: "left", value: "frist_name" },
        { text: "นามสกุล", align: "left", value: "last_name" },

        { text: "สังกัดเดิม", align: "left", value: "college_name_old" },
        { text: "ครั้งที่", align: "center", value: "ctstime_s" },
        { text: "ปีที่", align: "center", value: "ctsyear_s" }
      ],

      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      }
    };
  },
  computed: {
    showHeaders() {
      return this.headersMap.filter(h => this.selectedHeaders.includes(h));
    },
    stats() {
      const total = this.conditons_transfer_successs.length;
      const reported = this.conditons_transfer_successs.filter(
        i => i.cts_report === "nb"
      ).length;
      const not_reported = this.conditons_transfer_successs.filter(
        i => i.cts_report === "dnb"
      ).length;
      const pending = total - reported - not_reported;

      return { total, reported, not_reported, pending };
    }
  },
  created() {
    // Set default visible headers
    const defaultKeys = [
      "cts_report",
      "cts_datetime",
      "cts_files",
      "college_name_new",
      "title_s",
      "frist_name",
      "last_name",
      "college_name_old"
    ];
    this.selectedHeaders = this.headersMap.filter(h =>
      defaultKeys.includes(h.value)
    );
  },
  async mounted() {
    await this.periodQuery();
    await this.conditons_transfer_successQueryAll();
    logSensitiveAccess(
      this.$http,
      "conditons_transfer_success_reportmv_director",
      "view",
      `รอบ ${this.times_select}/${this.years_select}`
    );
  },
  methods: {
    // --- Data Fetching ---
    async periodQuery() {
      try {
        // ใช้ period_id เดียวกับ admin/transference_manage_report.vue (รอบดำเนินการย้ายสายบริหารปัจจุบัน)
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_id: "101"
        });
        this.periods = result.data;
        if (this.periods.period_times)
          this.times_select = this.periods.period_times;
        if (this.periods.period_year)
          this.years_select = this.periods.period_year;
      } catch (e) {
        console.error("Period Error", e);
      }
    },

    async conditons_transfer_successQueryAll() {
      this.loading = true;
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.periods.period_times,
          ctsyear_s: this.periods.period_year,
          ctsname_position: "ผู้บริหาร"
        });
        this.conditons_transfer_successs = result.data;
      } catch (e) {
        this.showSnackbar("error", "โหลดข้อมูลไม่สำเร็จ");
      } finally {
        this.loading = false;
      }
    },

    async searchTimeYear() {
      this.loading = true;
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.times_select,
          ctsyear_s: this.years_select,
          ctsname_position: "ผู้บริหาร"
        });
        this.conditons_transfer_successs = result.data;
        this.showSnackbar("success", `พบข้อมูล ${result.data.length} รายการ`);
      } catch (e) {
        this.showSnackbar("error", "ค้นหาล้มเหลว");
      } finally {
        this.loading = false;
      }
    },

    // --- Actions ---
    async cancelmvDirector(id_cts) {
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          id_cts: id_cts
        });
        this.conditons_transfer_successs_director = result.data;

        const confirm = await Swal.fire({
          title: "ยืนยันการยกเลิกรายการ?",
          text: `ชื่อ: ${this.conditons_transfer_successs_director.full_name}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          confirmButtonText: "ยืนยันลบ",
          cancelButtonText: "ยกเลิก"
        });

        if (confirm.isConfirmed) {
          // 1. Delete File if exists
          if (this.conditons_transfer_successs_director.cts_files) {
            await this.$http.post("deletefile.php", {
              ApiKey: this.ApiKey,
              filename:
                "../HRvecfiles/" +
                this.conditons_transfer_successs_director.cts_files
            });
          }

          // 2. Clear Data
          this.conditons_transfer_successs_director.ApiKey = this.ApiKey;
          this.conditons_transfer_successs_director.cts_report = "";
          this.conditons_transfer_successs_director.cts_datetime = "";
          this.conditons_transfer_successs_director.cts_files = "";
          this.conditons_transfer_successs_director.cts_college_cc = "";

          // 3. Update DB
          let resUpdate = await this.$http.post(
            "conditons_transfer_success.update.php",
            this.conditons_transfer_successs_director
          );

          if (resUpdate.data.status === true) {
            Swal.fire("สำเร็จ", "ยกเลิกข้อมูลเรียบร้อย", "success");
            await this.conditons_transfer_successQueryAll();
          } else {
            Swal.fire("ผิดพลาด", "ไม่สามารถอัปเดตข้อมูลได้", "error");
          }
        }
      } catch (e) {
        console.error(e);
        Swal.fire("Error", "เกิดข้อผิดพลาดในการเชื่อมต่อ", "error");
      }
    },

    // --- Utilities ---
    exportToExcel() {
      const filename = `Report_Movement_Director_${this.years_select}_${this.times_select}.xlsx`;
      logSensitiveAccess(
        this.$http,
        "conditons_transfer_success_reportmv_director",
        "export",
        filename
      );

      const exportData = this.conditons_transfer_successs.map(item => ({
        สถานะรายงานตัว:
          item.cts_report === "nb"
            ? "รายงานตัวแล้ว"
            : item.cts_report === "dnb"
            ? "ไม่มา"
            : "รอ",
        วันที่รายงานตัว: item.cts_datetime,
        "ชื่อ-สกุล": `${item.title_s}${item.frist_name} ${item.last_name}`,
        สังกัดเดิม: item.college_name_old,
        สังกัดใหม่: item.college_name_new,
        "ปี/ครั้งที่": `${item.ctsyear_s}/${item.ctstime_s}`
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report_MV_Director");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });
      saveAs(data, filename);
    },

    showSnackbar(color, text) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.icon =
        color === "success" ? "mdi-check-circle" : "mdi-alert-circle";
      this.snackbar.show = true;
    }
  }
};
</script>

<style scoped>
/* Custom Table overrides if needed */
</style>
